import { render, staticRenderFns } from "./_Destroy.vue?vue&type=template&id=57d6e580&"
import script from "./_Destroy.vue?vue&type=script&lang=js&"
export * from "./_Destroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports